import React from 'react';

export function Splash() {
  return <div className="fixed inset-2/4 bg-white bg-opacity-0 z-50 loader font-bold text-center">IQ</div>;
}